import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { SUPPORTED_LANGUAGES } from '../i18n';

// Simple language dropdown — persists the choice via i18next-browser-languagedetector's
// localStorage cache (see src/i18n.js), so the pick is remembered across sessions.
// `tone` controls contrast against the two chrome backgrounds it's dropped into:
// a light card (Login) vs. a dark/light navbar (StudentLayout/AppShell).
const TONE_CLASSES = {
  light: 'bg-white/80 border-slate-300 text-[#241f1a]',
  dark: 'bg-white/10 border-white/20 text-white',
  navbar: 'bg-transparent border-slate-300 text-slate-700',
};

const LanguageSwitcher = ({ tone = 'light', className = '' }) => {
  const { t, i18n } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div className={['inline-flex items-center gap-1.5', className].join(' ')}>
      <Globe className="w-4 h-4 flex-shrink-0 opacity-60" aria-hidden="true" />
      <select
        aria-label={t('common.selectLanguage')}
        value={i18n.resolvedLanguage || i18n.language}
        onChange={handleChange}
        className={[
          'text-sm rounded-lg border px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-themePrimary/40 cursor-pointer',
          TONE_CLASSES[tone] || TONE_CLASSES.light,
        ].join(' ')}
      >
        {SUPPORTED_LANGUAGES.map(({ code, label }) => (
          <option key={code} value={code} className="text-[#241f1a]">
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
